import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import contactImage from "../../assets/valvo.jpg";
import "./contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    industry: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const form = useRef();

  const industries = [
    "Crushers and Mining",
    "Rubber",
    "Logistics and Transportation",
    "Cold Storage Plants"
  ];
  
  let currentIndex = -1;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === "industry" && value.length > 2) {
      setSuggestions(industries.filter(industry => industry.toLowerCase().includes(value.toLowerCase())));
    } else if (name === "industry" && value.length <= 2) {
      setSuggestions([]);
    }
  };

  const handleSuggestionItem = (suggestion) => {
    setFormData({ ...formData, industry: suggestion });
    setSuggestions([]);
  }

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      currentIndex = (currentIndex + 1) % suggestions.length;
      updateFocus();
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      currentIndex = (currentIndex - 1 + suggestions.length) % suggestions.length;
      updateFocus();
    } else if (e.key === "Enter" && currentIndex !== -1) {
      e.preventDefault();
      document.querySelectorAll(".suggestion-item")[currentIndex].click();
    }
  }

  const updateFocus = () => {
    document.querySelectorAll(".suggestion-item").forEach((item, index) => {
      if (index === currentIndex) {
        item.classList.add("highlight");
        item.scrollIntoView({ block: 'nearest' });
      } else {
        item.classList.remove("highlight")
      }
    })
  };

  const handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert(`${text} copied to clipboard!`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    emailjs
      .send(
        "service_56t5n24",
        "template_l4nfmni",
        formData,
        "82L7an72ChQMUcPP4"
      )
      .then(() => {
        alert("Message sent successfully! We will be calling you within 24 Hours");
        setIsLoading(false);
        setFormData({ name: "", phone: "", industry: "" });
      })
      .catch((err) => {
        console.error("Failed to send message: ", err);
        alert("Failed to send message. Please try again.");
        setIsLoading(false);
        setFormData({ name: "", phone: "", industry: "" });
      });
  };

  return (
    <div className="contact-container">
      <div
        className="contact-banner"
        style={{ backgroundImage: `url(${contactImage})` }}
      >
        <div className="contact-banner-content">
          <h1 className="contact-title">Ask for Quotation</h1>
          <p className="contact-subtitle">
            Discuss your requirements, explore solutions, and connect with us for
            tailored services. We'll get back to you within 24 hours!
          </p>
        </div>
      </div>

      <div className="contact-content">
        <form ref={form} className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name (Industry/Personal)</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your name"
            />
          </div>

          <div className="form-group position-relative">
            <label htmlFor="industry">Select your Industry</label>
            <input
              type="text"
              id="industry"
              name="industry"
              value={formData.industry}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              required
              placeholder="Enter your industry"
            />

            <div
              className={`suggestions-box ${suggestions.length > 0 ? 'active' : ''}`}
              tabIndex="0"
            >
              {suggestions.map((suggestion) => {
                const matchIndex = suggestion
                  .toLowerCase()
                  .indexOf(formData.industry.toLowerCase());
                const beforeMatch = suggestion.slice(0, matchIndex);
                const matchText = suggestion.slice(
                  matchIndex,
                  matchIndex + formData.industry.length
                );
                const afterMatch = suggestion.slice(matchIndex + formData.industry.length);

                return (
                  <div
                    className="suggestion-item"
                    key={suggestion}
                    onClick={() => handleSuggestionItem(suggestion)}
                  >
                    {beforeMatch}
                    <strong>{matchText}</strong>
                    {afterMatch}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Enter your phone number"
            />
          </div>

          <button type="submit" className="submit-button" disabled={isLoading}>
            Send Message
            {isLoading ? <span className="loader"></span> : null}
          </button>
        </form>


        <div className="contact-info">
          <h2>Contact Us Directly</h2>
          <p className="contact-description">
            You can also get in touch with us directly using the contact details
            below. We are avaialble 24/7.
          </p>

          <button
            className="contact-button"
            onClick={() =>
              handleCopyToClipboard("+91 9342943399") || window.open("tel:+91 9342943399")
            }
          >
            📞 +91 9342943399
          </button>

          <button
            className="contact-button"
            onClick={() =>
              window.open("mailto:southzoneils@gmail.com")
            }
          >
            ✉️ southzoneils@gmail.com
          </button>

          <button
            className="contact-button"
            onClick={() =>
              window.open("https://wa.me/919342943399?text=Hello%20I%20would%20like%20to%20connect")
            }
          >
            💬 WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default Contact;
